module.exports = __webpack_public_path__ + "static/media/meteor-dribbble.05da47eb.jpg";